import React, { useState, useEffect } from "react";
import { Input } from "reactstrap";
import { useCompanies } from "../../../hooks/companies";
import SpecificEmpresaRequiredNotice from "../../../components/SpecificEmpresaRequiredNotice";
import { AUTOPILOT_COLORS } from "../../../components/autopilot/styles";
import api from "services/api";
import ParametrosPorAssunto from "./porAssunto/ParametrosPorAssunto";
import MAPA_TRANSPORTADORA from "./porAssunto/mapas/transportadora";

// Parâmetros do vínculo embarcador × transportadora (H1, PO1-3259). O seletor de
// transportadora é LOCAL à tela: começa na transportadora do cabeçalho global, mas
// trocar aqui não mexe na seleção global (antes mexia, e isso afetava as outras
// telas). O contexto (EmbarcadorTransportadora.Id) segue vindo de
// GET /parametros/resolve/transportadora.
const labelStyle = {
  display: "block",
  marginBottom: "0.3rem",
  color: AUTOPILOT_COLORS.muted,
  fontSize: "0.72rem",
  fontWeight: 600,
  textTransform: "uppercase",
  letterSpacing: "0.06em",
};

export default function ParametrosTransportadora() {
  const { empresaId, hasEmpresaSelection, transportadora, optionsTransportadora } = useCompanies();

  const globalId = transportadora ? transportadora.value : null;
  const [transportadoraId, setTransportadoraId] = useState(globalId);
  const [contextoId, setContextoId] = useState(null);
  const [resolving, setResolving] = useState(false);
  const [erro, setErro] = useState(null);

  // Trocou o embarcador no cabeçalho: a lista muda, volta para a seleção global.
  useEffect(() => {
    setTransportadoraId(globalId);
  }, [empresaId, globalId]);

  useEffect(() => {
    setContextoId(null);
    setErro(null);
    if (!empresaId || !transportadoraId) return undefined;

    let ativo = true;
    setResolving(true);
    api
      .get("/parametros/resolve/transportadora", {
        params: { idEmbarcador: empresaId, idTransportadora: transportadoraId },
      })
      .then((res) => {
        if (ativo) setContextoId(res.data.contextoId);
      })
      .catch((e) => {
        if (ativo) setErro(e.response?.data?.error || "Vínculo não encontrado");
      })
      .finally(() => {
        if (ativo) setResolving(false);
      });
    return () => {
      ativo = false;
    };
  }, [empresaId, transportadoraId]);

  if (!hasEmpresaSelection) {
    return (
      <div className="content">
        <SpecificEmpresaRequiredNotice message="Selecione um embarcador específico para ver os parâmetros das transportadoras." />
      </div>
    );
  }

  const opcoes = optionsTransportadora || [];
  const selecionada = opcoes.find((t) => String(t.value) === String(transportadoraId));

  const seletor = (
    <div style={{ maxWidth: 420 }}>
      <span style={labelStyle}>Transportadora</span>
      <Input
        type="select"
        value={transportadoraId || ""}
        onChange={(e) => setTransportadoraId(e.target.value ? Number(e.target.value) || e.target.value : null)}
        aria-label="Transportadora"
      >
        <option value="">Selecione uma transportadora...</option>
        {opcoes.map((t) => (
          <option key={t.value} value={t.value}>
            {t.label}
          </option>
        ))}
      </Input>
      {erro ? <div style={{ color: AUTOPILOT_COLORS.statusDanger, marginTop: 6, fontSize: "0.8rem" }}>{erro}</div> : null}
      {!opcoes.length ? (
        <div style={{ color: AUTOPILOT_COLORS.muted, marginTop: 6, fontSize: "0.8rem" }}>Nenhuma transportadora vinculada a este embarcador.</div>
      ) : null}
    </div>
  );

  return (
    <ParametrosPorAssunto
      escopo="transportadora"
      contextoId={resolving ? null : contextoId}
      mapa={MAPA_TRANSPORTADORA}
      titulo="Parâmetros de Transportadora"
      subtitulo={
        selecionada
          ? `Regras específicas do vínculo com ${selecionada.label}: fatura, impostos, cálculo de frete e envio de notas.`
          : "Regras específicas de cada transportadora vinculada ao embarcador: fatura, impostos, cálculo de frete e envio de notas."
      }
      cabecalhoExtra={seletor}
      mensagemSemContexto={
        resolving
          ? "Localizando o vínculo com a transportadora..."
          : transportadoraId
            ? erro || "Vínculo não encontrado para esta transportadora."
            : "Selecione uma transportadora para ver os parâmetros do vínculo."
      }
    />
  );
}
